var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteboard = function SvgWhiteboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.44 13.4a2.36 2.36 0 0 0-4.33-1.3 2.36 2.36 0 0 0-4.32 1.3c0 2.76 4.32 4.33 4.32 4.33s4.33-1.57 4.33-4.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15.82 2.46h4.77V22.5H3.41V2.46h4.77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15.82 1.5v1.91a1.92 1.92 0 0 1-1.91 1.91h-3.82a1.92 1.92 0 0 1-1.91-1.91V1.5z"
  })));
};
export default SvgWhiteboard;